
<div class="wrap" *ngIf="availableWallets">
    <div class="list-group"
            style="margin-bottom: 25px; max-height: 400px; overflow: scroll; ">
        <a (click)="selectedWallet = wallet"
            *ngFor="let wallet of availableWallets"
            [class.selected_wallet]="selectedWallet && wallet.guid === selectedWallet.guid"
            class="list-group-item list-group-item-action"
            style="display: flex; cursor: pointer; background: #F9FCFF "
        >
            <div style="width: 70%;">
                {{ wallet.title }}
            </div>
        </a>
    </div>
    <button  class="button-icon primary-button size-xl" 
    [disabled]="formState==='Submitting'"
    (click)="changeContractWallet()"        >
        {{'CONTRACTS.CARD.CHANGE_WALLET'|translate}}
    </button>
</div>